import { useEffect, useReducer, useState,useContext } from 'react';
import './App.css';
import { MensajeContActualizacion } from './Context/LoadingContext';
import Body from './Paginas/Body';
import Footer from './Paginas/Footer';
import { Loading } from './Paginas/Modelo';
import { Get } from './Servicios/ApiRest';
import { Paginas } from './Servicios/Ruta/Servicio';

function App() {

  const [selectComuna,SetSelectComuna]=useState<any[]>([])
  const [stateCalculadora,dispachCalculadora]=useReducer(reducerCalculadora,{cantidad:1,comuna:""})
  const [Valor,SetValor]=useState<number>(0)
  const [activador,SetActivador]=useState<boolean>(false)
  const {SetLoading}=useContext(MensajeContActualizacion)
  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0
  })

  useEffect(()=>
  {
    cargaComunas(1)
    SetActivador(false)
  },[])

  function reducerCalculadora(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          return {cantidad:1,comuna:"Iquique"}
      }
    
      return state;
    }

    function cambioCalculadora(event:any)
    {
      if(event.target.value>=1)
      {
        dispachCalculadora({type:"cambio",input:{
          name:event.target.name,
          value:Math.round(event.target.value)
        }})
      }
      
     
      
    }

    function cambioCalculadoraComuna(event:any)
    {
      
      dispachCalculadora({type:"cambio",input:{
        name:"comuna",
        value:event.target.value
      }})
    }

    function cambioComuna(event:any)
    {
      cargaComunas(event.target.value)
    }

    const cargaComunas=(id:number)=>
    {
      SetSelectComuna([]);
      const ruta=Paginas.comuna.replace("@id",id+"")
    const comunas=Get(ruta)
    comunas.then(resultado=>
      {
        resultado.comuna.map((e:any)=>
        {
          
          SetSelectComuna((a:any)=>[...a,<option value={e.nombre}>{e.nombre}</option>])
        });
        dispachCalculadora({type:"cambio",input:{
          name:"comuna",
          value:resultado.comuna[0].nombre
        }})
        
      })
    }

    const mostrarDatos=()=>
    {
       const dato=Get(Paginas.calculadoraDespacho.replace("@id", stateCalculadora.comuna+"@"+stateCalculadora.cantidad))
       dato.then(resultado=>
        {
          SetLoading(false)
          SetActivador(true)
          if(resultado.objetos.status==200)
          {
            SetValor(resultado.objetos.data)
          }else
          {
            SetValor(-1)
          }
        })
    }

  return (
    <>
    <div className="fondo-gris pt-2 pt-sm-4">
	<main className="form-signin w-100 m-auto">
 <section  id="calculadora">
   <h1 className="pb-2">Calcula el costo de tu envío</h1>
      <div className="row py-1">
        <div className="col-12">
          <label className="form-label">Región</label>
          <select className="form-select" onChange={cambioComuna}>
            <option value="1">Región I</option>
            <option value="2">Región II</option>
            <option value="3">Región III</option>
            <option value="4">Región IV</option>
            <option value="5">Región V</option>
            <option value="6">Región VI</option>
            <option value="7">Región VII</option>
            <option value="8">Región VIII</option>
            <option value="9">Región IX</option>
            <option value="10">Región X</option>
            <option value="11">Región XI</option>
            <option value="12">Región XII</option>
            <option value="13">Región Metropolitana</option>
            <option value="14">Región XIV</option>
            <option value="15">Región XV</option>
            <option value="16">Región XVI</option>
          </select>
        </div>
      </div>
      <div className="row py-1">
        <div className="col-12">
          <label className="form-label">Comuna</label>
          <select className="form-select" id="comuna" onChange={cambioCalculadoraComuna}>
          {selectComuna}
          </select>
        </div>
      </div>
	      <div className="row py-1">
      <div className="col-12">
        <label className="form-label">Cantidad de medicamentos</label>
        <input type="number" className="form-control w-25" id="cantidad" name="cantidad" pattern="^[1-9]+" min={1} value={stateCalculadora.cantidad}  onChange={cambioCalculadora}/>
		</div></div>
      <div className="row py-3">
        <div className="col-12">
          <button type="submit" className="btn btn-rojo" onClick={()=>{mostrarDatos();SetLoading(true)}}>Calcular</button>
        </div>
      </div>
      <div className="row py-3">
        <div className="col-12">
          {activador?Valor==-1?<div className="alert alert-danger" role="alert"> No se realiza despacho a la comuna seleccionada </div>:<div className="alert alert-success" role="alert"> El costo del envío es ${formatter.format(Valor)} </div>:null}

        </div>
      
    </div>
  </section>
</main>
	</div>

  
    <Loading></Loading>
    </>
  );
}

export default App;
